/**
 * Escrituras de la lección elder-1 (ministración). DyC 20 y 107 alineados con scriptures.training.core3; DyC 42, Santiago y Marcos según churchofjesuschrist.org.
 */
import type { Scripture } from './scriptures';

export const elder1TrainingScripturesEs: Scripture[] = [
  {
    id: 'dc-20-38-45',
    reference: 'Doctrina y Convenios 20:38–45',
    text:
      'El deber de los élderes, presbíteros, maestros, diáconos y miembros de la Iglesia de Cristo: Un apóstol es un élder, y es suyo el llamamiento de bautizar; y ordenar a otros élderes, presbíteros, maestros y diáconos; y administrar el pan y el vino, emblemas de la carne y sangre de Cristo, y confirmar por la imposición de manos a los que se bautizan en la iglesia, para que reciban el bautismo de fuego y del Espíritu Santo, de acuerdo con las Escrituras; y enseñar, exponer, exhortar, bautizar y velar por la iglesia; y confirmar a los miembros de la iglesia por la imposición de manos y el otorgamiento del Espíritu Santo; y hacerse cargo de todas las reuniones. Los élderes han de dirigir las reuniones según los guíe el Espíritu Santo, de acuerdo con los mandamientos y revelaciones de Dios.',
    verses: [
      {
        verse: 38,
        text: 'El deber de los élderes, presbíteros, maestros, diáconos y miembros de la Iglesia de Cristo: Un apóstol es un élder, y es suyo el llamamiento de bautizar;',
      },
      {
        verse: 39,
        text: 'y ordenar a otros élderes, presbíteros, maestros y diáconos;',
      },
      {
        verse: 40,
        text: 'y administrar el pan y el vino, emblemas de la carne y sangre de Cristo,',
      },
      {
        verse: 41,
        text: 'y confirmar por la imposición de manos a los que se bautizan en la iglesia, para que reciban el bautismo de fuego y del Espíritu Santo, de acuerdo con las Escrituras;',
      },
      {
        verse: 42,
        text: 'y enseñar, exponer, exhortar, bautizar y velar por la iglesia;',
      },
      {
        verse: 43,
        text: 'y confirmar a los miembros de la iglesia por la imposición de manos y el otorgamiento del Espíritu Santo;',
      },
      {
        verse: 44,
        text: 'y hacerse cargo de todas las reuniones.',
      },
      {
        verse: 45,
        text: 'Los élderes han de dirigir las reuniones según los guíe el Espíritu Santo, de acuerdo con los mandamientos y revelaciones de Dios.',
      },
    ],
    context: 'Deberes del élder: ordenanzas, enseñanza, velar por la iglesia y dirigir reuniones.',
  },
  {
    id: 'james-5-14-15',
    reference: 'Santiago 5:14–15',
    text:
      '¿Está alguno enfermo entre vosotros? Llame a los ancianos de la iglesia, y oren ellos por él, ungiéndole con aceite en el nombre del Señor. Y la oración de fe salvará al enfermo, y el Señor lo levantará; y si ha cometido pecados, le serán perdonados.',
    verses: [
      {
        verse: 14,
        text: '¿Está alguno enfermo entre vosotros? Llame a los ancianos de la iglesia, y oren ellos por él, ungiéndole con aceite en el nombre del Señor.',
      },
      {
        verse: 15,
        text: 'Y la oración de fe salvará al enfermo, y el Señor lo levantará; y si ha cometido pecados, le serán perdonados.',
      },
    ],
    context: 'Oración de fe, unción con aceite y ancianos de la iglesia.',
  },
  {
    id: 'dc-42-44-45',
    reference: 'Doctrina y Convenios 42:44–45',
    text:
      'Y los élderes de la iglesia, dos o más, serán llamados, y orarán por ellos y les impondrán las manos en mi nombre; y si murieren, morirán para mí; y si vivieren, vivirán para mí. Viviréis juntos en amor, al grado de que lloraréis por los que mueran, y más particularmente por aquellos que no tengan la esperanza de una resurrección gloriosa.',
    verses: [
      {
        verse: 44,
        text: 'Y los élderes de la iglesia, dos o más, serán llamados, y orarán por ellos y les impondrán las manos en mi nombre; y si murieren, morirán para mí; y si vivieren, vivirán para mí.',
      },
      {
        verse: 45,
        text: 'Viviréis juntos en amor, al grado de que lloraréis por los que mueran, y más particularmente por aquellos que no tengan la esperanza de una resurrección gloriosa.',
      },
    ],
    context: 'Los élderes oran e imponen manos a los enfermos; el pueblo del convenio vive en amor y duelo piadoso.',
  },
  {
    id: 'dc-107-12',
    reference: 'Doctrina y Convenios 107:12',
    text:
      'El sumo sacerdote y el élder deben administrar las cosas espirituales, de acuerdo con los convenios y mandamientos de la iglesia; y tienen el derecho de oficiar en todos estos oficios de la iglesia cuando no esté presente una autoridad mayor.',
    verses: [
      {
        verse: 12,
        text: 'El sumo sacerdote y el élder deben administrar las cosas espirituales, de acuerdo con los convenios y mandamientos de la iglesia; y tienen el derecho de oficiar en todos estos oficios de la iglesia cuando no esté presente una autoridad mayor.',
      },
    ],
    context: 'El élder administra en cosas espirituales según los convenios de la iglesia.',
  },
  {
    id: 'mark-16-18',
    reference: 'Marcos 16:18',
    text:
      'Tomarán serpientes en las manos y, si bebieren cosa mortífera, no les dañará; sobre los enfermos impondrán sus manos, y sanarán.',
    verses: [
      {
        verse: 18,
        text: 'Tomarán serpientes en las manos y, si bebieren cosa mortífera, no les dañará; sobre los enfermos impondrán sus manos, y sanarán.',
      },
    ],
    context: 'Señales que acompañan a los creyentes, incluida la imposición de manos sobre los enfermos.',
  },
];
